// DS7.4
import React from 'react';
import c from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import GhostButton from '../Buttons/GhostButton';
import SolidButton from '../Buttons/SolidButton';
import s from './DialogBanner.scss';
const DialogBanner = ({ className, message, ctaLabel, ctaBiData, dismissLabel, dismissBiData, linkLabel, linkHref, customCtaButton, onDismiss, onClick })=>{
    return /*#__PURE__*/ React.createElement(Section, {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: s['message']
    }, message), linkLabel && linkHref && /*#__PURE__*/ React.createElement("a", {
        className: s['link'],
        href: linkHref
    }, linkLabel), (dismissLabel || ctaLabel) && /*#__PURE__*/ React.createElement("div", {
        className: s['buttons']
    }, dismissLabel && /*#__PURE__*/ React.createElement(GhostButton, {
        className: s['button'],
        variant: "main",
        size: "small",
        onClick: onDismiss,
        biData: dismissBiData
    }, dismissLabel), ctaLabel && /*#__PURE__*/ React.createElement(SolidButton, {
        className: s['button'],
        variant: "approval-green",
        size: "small",
        onClick: onClick,
        biData: ctaBiData
    }, ctaLabel)), customCtaButton);
};
DialogBanner.displayName = 'DialogBanner';
export default DialogBanner;
